import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import type { ARCommunication } from '../../data/mockARData';

interface EmailDetailModalProps {
  communication: ARCommunication | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

function formatDateTime(dateStr: string): string {
  return new Date(dateStr).toLocaleString('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

export function EmailDetailModal({
  communication,
  open,
  onOpenChange,
}: EmailDetailModalProps) {
  if (!communication) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Email Details</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {/* Meta info */}
          <div className="space-y-2">
            <div className="flex gap-8">
              <span className="text-muted-foreground w-20">Date</span>
              <span>{formatDateTime(communication.date)}</span>
            </div>
            <div className="flex gap-8">
              <span className="text-muted-foreground w-20">Response</span>
              <span>{communication.response}</span>
            </div>
          </div>

          {/* Email Content */}
          <div className="space-y-2">
            <h3 className="font-semibold">Email Content</h3>
            <div className="border rounded-lg p-4 bg-muted/30">
              <div className="font-medium mb-4">
                Subject: {communication.subject}
              </div>
              <div className="whitespace-pre-wrap text-sm leading-relaxed">
                {communication.emailBody}
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
